import React from 'react'
import './style.scss'

export default function Badge({
  status,
  variant,
  children,
  label,
  showDot,
  dotColor,
  size = 'md',
  icon,
  className = '',
  style = {},
  onClick,
  ...restProps
}) {
  const activeVariant = (variant || status || 'active').toLowerCase()

  let variantClass = 'badge-active'
  if (['closed', 'inactive', 'gray'].includes(activeVariant)) {
    variantClass = 'badge-inactive'
  } else if (['low', 'danger', 'red'].includes(activeVariant)) {
    variantClass = 'badge-low'
  } else if (['category', 'cat'].includes(activeVariant)) {
    variantClass = 'badge-category'
  } else if (['open', 'active', 'teal'].includes(activeVariant)) {
    variantClass = 'badge-active'
  }

  const isCategory = activeVariant === 'category' || activeVariant === 'cat'
  const shouldShowDot = showDot !== undefined ? showDot : !isCategory

  const defaultLabel = status
    ? status.charAt(0).toUpperCase() + status.slice(1)
    : ''
  const content = children || label || defaultLabel

  const sizeClass =
    size === 'sm' ? 'badge-sm' : size === 'lg' ? 'badge-lg' : 'badge-md'
  const combinedClassName = `cb-badge ${variantClass} ${sizeClass} ${className}`.trim()

  return (
    <span
      className={combinedClassName}
      style={style}
      onClick={onClick}
      {...restProps}
    >
      {icon ? (
        <span className='cb-badge-icon'>{icon}</span>
      ) : shouldShowDot ? (
        <span
          className='cb-badge-dot'
          style={dotColor ? { backgroundColor: dotColor } : {}}
        />
      ) : null}
      {content && <span className='cb-badge-label'>{content}</span>}
    </span>
  )
}
